export default "__VITE_ASSET__CyPYaws6__"